import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { getLocale, addLocaleEventListener } from '@zenlayer/zen-intl18';
import { useLatest } from 'ahooks';
/**
 * 自定义hook
 * @function
 * 用于监听和管理应用中的语言设置，语言发生变化时更新in18n中locale状态
 */

export var useAddLocaleEventListener = function useAddLocaleEventListener() {
  var _useState = useState(getLocale()),
      _useState2 = _slicedToArray(_useState, 2),
      locale = _useState2[0],
      setLocale = _useState2[1];

  var latestLocaleRef = useLatest(locale);
  useEffect(function () {
    var removeEventListener = addLocaleEventListener(function (newLocale, e) {
      if (newLocale !== latestLocaleRef.current) {
        setLocale(newLocale);
      }
    });
    return function () {
      removeEventListener();
    };
  }, []);
  return locale;
};